import { render, staticRenderFns } from "./hero.vue?vue&type=template&id=f4016554"
import script from "./hero.vue?vue&type=script&lang=ts"
export * from "./hero.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/vercel/path0/components/navbar.vue').default,UiIconCheck: require('/vercel/path0/components/ui/icon/check.vue').default,FilterBar: require('/vercel/path0/components/filter/filter-bar.vue').default,UiLink: require('/vercel/path0/components/ui/link.vue').default})
